// removed by extract-text-webpack-plugin
module.exports = {"About":"About__About__2vr83","Badge":"About__Badge__3idCk","Text":"About__Text__3-xE2","Flex30":"About__Flex30__1PV5Y","Image":"About__Image__omssN","Title":"About__Title__37PDG","Description":"About__Description__1Yie0","ImageMobileOnly":"About__ImageMobileOnly__1wMWJ"};


//////////////////
// WEBPACK FOOTER
// ./client/src/containers/Home/About/About.css
// module id = 405
// module chunks = 0